export const SELLER_TYPES = [
  "Farm", "Smallholding", "Farm Shop", "Butcher", "Baker", "Beekeeper",
  "Dairy & Cheese", "Drinks Producer", "Preserves & Pantry", "Other Artisan Producer",
];
// Seller types that produce their own goods and are exempt from the 'Sourced from' requirement
export const SELF_PRODUCING_TYPES = ["Farm", "Smallholding"];

export const CATEGORIES = [
  "Eggs", "Meat", "Raw Milk", "Veg", "Dairy",
  "Honey & Bee Products", "Bread & Baked Goods", "Cheese & Dairy",
  "Drinks (cider, wine, juice)", "Preserves, Jams & Chutneys", "Store Cupboard", "Other",
];
export const UNITS = ["per dozen", "per kg", "per litre", "per bunch", "each", "per pack", "per jar", "per loaf", "per bottle"];
export const RADII = [5, 10, 25, 50];

// Farm-level certification types
export const CERT_TYPES = [
  { value: "certified_organic", label: "Certified Organic" },
  { value: "in_conversion", label: "In Conversion to Organic" },
  { value: "other", label: "Other Certification (e.g. Red Tractor, RSPCA Assured, Pasture for Life, LEAF)" },
  { value: "none", label: "No Certification" },
];

// Shopper certification filter options
export const CERT_FILTERS = [
  { value: "any", label: "Any" },
  { value: "certified_organic", label: "Certified Organic" },
  { value: "in_conversion", label: "In Conversion" },
  { value: "any_certification", label: "Any Certification" },
  { value: "no_certification", label: "No Certification" },
];

// Category -> self-declared production tick boxes
export const PRODUCTION_TAGS = {
  Veg: [
    "No pesticides used", "Minimal / reduced pesticide use", "No artificial fertilisers",
    "Spray free", "Grown outdoors / field grown", "Grown under glass or polytunnel",
    "Heritage or heirloom variety", "Non-GMO seed",
    "Picked to order / harvested fresh on collection day", "Wonky or imperfect produce",
  ],
  Eggs: [
    "Free range", "Pasture raised", "Barn / indoor", "Small flock (under 350 birds)",
    "Non-GMO feed", "Organic feed", "No routine antibiotics", "Heritage breed", "Collected daily",
  ],
  Meat: [
    "Grass fed", "Grass finished", "Pasture raised / outdoor reared", "Free range",
    "Rare or native breed", "No routine antibiotics", "No growth hormones", "Non-GMO feed",
    "Dry aged", "Slaughtered locally / low food miles", "Whole or half animal boxes available",
  ],
  "Raw Milk": [
    "Raw / unpasteurised", "Pasteurised", "Grass fed herd", "Single herd", "A2 milk",
    "Jersey / Guernsey herd", "No routine antibiotics", "Bottled on farm",
  ],
  Dairy: [
    "Raw / unpasteurised", "Pasteurised", "Grass fed herd", "Single herd", "A2 milk",
    "Jersey / Guernsey herd", "No routine antibiotics", "Bottled on farm",
  ],
  Other: [
    "Non-GMO", "No pesticides", "Small batch", "Made on farm", "Locally sourced ingredients",
  ],
  "Honey & Bee Products": [
    "Raw / unpasteurised", "Single apiary", "Local wildflower", "Cold extracted", "Comb honey", "No treatments used",
  ],
  "Bread & Baked Goods": [
    "Sourdough", "Slow fermented", "Locally milled flour", "No additives or preservatives", "Baked to order", "Wood fired",
  ],
  "Cheese & Dairy": [
    "Raw milk", "Pasteurised", "Single herd", "Farmhouse made", "Traditional rennet", "Aged on site",
  ],
  "Drinks (cider, wine, juice)": [
    "Made from own fruit", "Locally grown fruit", "Unfiltered", "No added sulphites", "Small batch", "Bottled on site",
  ],
  "Preserves, Jams & Chutneys": [
    "Made in small batches", "Own or local fruit", "No artificial pectin", "Seasonal",
  ],
  "Store Cupboard": [
    "Small batch", "Made on farm", "Locally sourced ingredients", "No additives or preservatives",
  ],
};

// Compact filter tag subset per category (for map filter panel)
export const FILTER_TAGS = {
  Veg: ["No pesticides used", "Spray free", "No artificial fertilisers", "Grown outdoors / field grown", "Heritage or heirloom variety"],
  Eggs: ["Free range", "Pasture raised", "Small flock (under 350 birds)", "Organic feed", "Non-GMO feed"],
  Meat: ["Grass fed", "Pasture raised / outdoor reared", "Rare or native breed", "No routine antibiotics", "No growth hormones"],
  "Raw Milk": ["Raw / unpasteurised", "Grass fed herd", "A2 milk", "Single herd"],
  Dairy: ["Grass fed herd", "A2 milk", "Bottled on farm", "Single herd"],
  Other: ["Non-GMO", "No pesticides", "Small batch", "Made on farm"],
  "Honey & Bee Products": ["Raw / unpasteurised", "Single apiary", "Local wildflower", "Cold extracted"],
  "Bread & Baked Goods": ["Sourdough", "Slow fermented", "Locally milled flour", "Wood fired"],
  "Cheese & Dairy": ["Raw milk", "Single herd", "Farmhouse made", "Aged on site"],
  "Drinks (cider, wine, juice)": ["Made from own fruit", "Unfiltered", "No added sulphites", "Small batch"],
  "Preserves, Jams & Chutneys": ["Made in small batches", "Own or local fruit", "Seasonal"],
  "Store Cupboard": ["Small batch", "Made on farm", "Locally sourced ingredients"],
};

export const STATUS_META = {
  pending: { label: "Pending", color: "bg-amber-100 text-amber-800 border-amber-200" },
  confirmed: { label: "Confirmed", color: "bg-blue-100 text-blue-800 border-blue-200" },
  ready: { label: "Ready", color: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  collected: { label: "Collected", color: "bg-stone-200 text-stone-700 border-stone-300" },
  cancelled: { label: "Cancelled", color: "bg-red-100 text-red-800 border-red-200" },
};
